import { createStore } from 'jotai'
import { createContext, ReactNode, useContext } from 'react'

export const BrandLibraryStoreContext = createContext<ReturnType<typeof createStore> | null>(null)

export function BrandLibraryStoreProvider({
	children,
	store,
}: {
	children: ReactNode
	store: ReturnType<typeof createStore>
}) {
	return (
		<BrandLibraryStoreContext.Provider value={store}>
			{children}
		</BrandLibraryStoreContext.Provider>
	)
}

export function useBrandLibraryStore({ overrideStore }: { overrideStore?: ReturnType<typeof createStore> } = {}) {
	const store = overrideStore ?? useContext(BrandLibraryStoreContext)
	if (!store) {
		throw new Error('BrandLibraryStoreContext not found')
	}
	return store
}
